import Vue from 'vue'

export const regionState = Vue.observable({
  isOpen: false,
  step: 1,
  currentRegion: 'tshk'
})

export const regionModal = {
  open(step = 1) {
    regionState.step = step
    regionState.isOpen = true
  },
  close() {
    regionState.isOpen = false
  },
  setRegion(code) {
    regionState.currentRegion = code
  }
}